<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__info">
      <div class="info-row">
        <span class="label">Работа:</span>
        <span class="value">{{ this.data?.body?.task_name }}</span>
      </div>
      <div class="info-row" v-if="this.data?.body?.unit_name">
        <span class="label">Единица измерения:</span>
        <span class="value">{{ this.data?.body?.unit_name }}</span>
      </div>
    </div>
    
    <div class="form__item">
      <CustomInput 
        label="Плановое значение" 
        :value="this.formData.plan_value"
        @change_input="(value) => onChange('plan_value', value)" 
        type="number"
        required 
      />
    </div>
    
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "edit-task-params",
  components: { CustomInput, CustomModalFooter },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        work_task_plan_id: this.data?.body?.work_task_plan_id || null,
        work_group_id: this.data?.body?.work_group_id || null,
        task_dict_id: this.data?.body?.task_dict_id || null,
        plan_value: this.data?.body?.plan_value || 0,
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  &__info {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;
    
    .info-row {
      display: flex;
      margin-bottom: 8px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .label {
        font-weight: 600;
        margin-right: 8px;
      }
      
      .value {
        color: #555;
      }
    }
  }

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>

